export enum LeadSource {
	ACEP = 50,
	AFTER_CARE = 34,
	ANATOMICAL_DONATION = 32,
	CEMETERY = 19,
	CEMETERY_POST_SERVICE = 38,
	CEMETERY_STEPPING_STONES = 36,
	CEP = 41,
	CHURCH = 25,
	CREMATION = 30,
	DEATH_IN_NEIGHBORHOOD = 31,
	DIRECT_MAIL = 11,
	DIRECT_MAIL_FH = 23,
	DIRECT_MAIL_PET = 40,
	DIRECT_MAIL_PHONE_APPEND = 55,
	EXPO_LEADS = 33,
	FAIR = 13,
	FILES = 15,
	FOREST_LAWN = 42,
	GROUND = 48,
	INSURANCE_ELEADS = 46,
	INTERNET = 54,
	INTERNET_FH = 29,
	INTERNET_VMP = 52,
	LTFS = 53,
	MOVIE = 17,
	NEWSPAPER_INSERT = 16,
	NEWSPAPER_VMP = 47,
	OTHER = 10,
	OTHER_FH = 28,
	PACKET_PROGRAM = 51,
	PERSONAL_REFERRAL = 26,
	PET_AFTER_CARE = 39,
	POST_SERVICE = 18,
	PRICE_INCREASE_LETTER = 22,
	REFERRAL = 3,
	REGISTER_APP = 43,
	REGISTER_BOOK = 27,
	SEMINAR = 20,
	SENIOR_LIST = 21,
	STEPPING_STONES = 12,
	TARGETED_DIRECT_MAIL = 37,
	UNFUNDED = 14,
	VETERANS_MEMORIAL_PROGRAM = 49,
	VISA_PRENEED_REQUEST = 24,
	WALK_IN_CALL_IN = 45,
	WWII_MEMORIAL = 35,

	// Adding these new enums that do not map to CRM
	ALTOGETHER_DIGITAL = 60,
	ALTOGETHER_MAIL = 61,
	COST_ESTIMATOR_REFERRAL = 62,
	EA_CORE_CONNECT = 63,
	EVERYTHING_AFTER_PLUS = 64,
	VMP_PHONE_APPEND = 65,
}
